import Marquee from "react-fast-marquee";

const ITEMS = [
  "التسويق العقاري",
  "الوساطة العقارية",
  "التأجير للغير",
  "SHIYADN REAL ESTATE ASSETS",
  "رؤيتك العقارية تبدأ من أصل ثابت",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-white/10 bg-deepnavy py-6 md:py-8"
      dir="ltr"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 md:mx-12 md:gap-12">
            <span
              className={`whitespace-nowrap ${
                /[A-Z]/.test(item)
                  ? "font-display text-lg md:text-2xl tracking-[0.3em] text-cream/70"
                  : "font-head text-xl md:text-3xl font-bold text-cream/85"
              }`}
            >
              {item}
            </span>
            <span className="inline-block h-2 w-2 rotate-45 bg-copper" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
